import { render, staticRenderFns } from "./RenderXmlJobSerp.vue?vue&type=template&id=978028e6"
import script from "./RenderXmlJobSerp.vue?vue&type=script&lang=js"
export * from "./RenderXmlJobSerp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports